import {
  init as sentryInit,
  captureException as sentryCaptureException,
  setTag,
  breadcrumbsIntegration,
  dedupeIntegration,
  functionToStringIntegration,
} from '@sentry/browser';
import type {ErrorEvent, EventHint} from '@sentry/browser';

export function initSentry(swScope: ServiceWorkerGlobalScope, version: string) {
  sentryInit({
    beforeSend: sentryBeforeSend,
    dsn: 'https://015d5ce7dd3142cd8fca094a50adbf69@d.dropbox.com/4505546831036416',
    defaultIntegrations: false,
    environment: process.env.NODE_ENV,
    // Enable a few integrations similar to exception_reporter.ts
    integrations: [breadcrumbsIntegration(), dedupeIntegration(), functionToStringIntegration()],
    release: version,
  });
  setTag('service_worker', 'true');
  setTag('service_worker_scope', new URL(swScope.registration.scope).pathname);
}

export function captureException(
  error: Error,
  level: 'error' | 'warning' | 'info' | 'debug' = 'error'
) {
  sentryCaptureException(error, {level});
}

function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('Sentry sending intercepted:\nEvent:\n', event, '\nEventHint:\n', hint);
    return null;
  }
  return event;
}
